import {
  Autocomplete,
  TextField,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import { addDays, isAfter } from "date-fns";
import useCountStore from "../components/store";
import Alerts from "../components/Alerts";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import AddToPhotosSharpIcon from "@mui/icons-material/AddToPhotosSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";

export default function AddBowDose({ user }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [timeOfDay, setTimeOfDay] = useState("");
  const [value, setValue] = useState("");
  const [partsofday, setPartsofday] = useState("");
  const { userData } = useContext(UserDataContext);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [lastId, setLastId] = useState();
  const handleChangeInput = (event) => {
    setValue(event.target.value);
    setShowApiResponse(false);
  };
  const handleChange = (event) => {
    setTimeOfDay(event.target.value);
    setShowApiResponse(false);
  };
  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };
  useEffect(() => {
    if (userData) {
      axios
        .get(API_URL + `/getbow/${userData.cookie}`)
        .then((response) => {
          setOptions(response.data);
          //console.log("pobrane ponownie: ", response.data);
        })
        .catch((error) => {
          console.error("Błąd w pobieraniu danych:", error);
        });
    }
  }, [userData, inputValue, lastId]);
  useEffect(() => {
    if (userData) {
      axios
        .get(API_URL + `/getpartsofday/${userData.cookie}`)
        .then((response) => {
          setPartsofday(response.data);
        })
        .catch((error) => {
          console.error("Błąd w pobieraniu danych:", error);
        });
    }
  }, [userData, inputValue]);
  const handleAddNewOption = async () => {
    if (inputValue && !options.includes(inputValue)) {
      const obj = {
        userId: userData.userId,
        bow: inputValue,
      };
      try {
        const response = await axios.post(
          API_URL + `/addbow/${userData.cookie}`,
          obj
        );
        setShowApiResponse(true);
        if (response.data.error_msg === 559) {
          setApiResponse({
            title: "UWAGA",
            severity: "warning",
            info: "Ten lek już został wcześniej zapisany!",
          });
          setInputValue("");
        }
        if (response.data.error_msg === 200) {
          if (response.data.lastId > 0) {
            setLastId(response.data.lastId);
            setInputValue("");
          }
          setApiResponse({
            color: "text-success",
            info: "Lek dopisany!",
          });
        }
      } catch (error) {
        console.error("There was an error editing the user!", error);
      }
    }
  };
  const count = useCountStore((state) => state.count);
  const setCount = useCountStore((state) => state.setCount);

  const handleSubmit = async () => {
    setCount(count + 1);

    if (selectedOption) {
      const formData = {
        selectedOption: selectedOption.id ? selectedOption.id : null,
        quantity: value,
        user: user,
        timeOfDay,
        selectedDate: selectedDate
          ? selectedDate.toISOString().split("T")[0]
          : null,
      };

      if (value === "") {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Nie wprowadzono dawki leku. Wpisz ilość tabletek, kropli itp. np. '0,5 tabletki'",
        });
        setShowApiResponse(true);
      } else if (timeOfDay === "") {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Nie wprowadzono pory dnia przyjęcia leku!",
        });
        setShowApiResponse(true);
      } else if (selectedOption.id) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Brak wybranego leku!",
        });
        setShowApiResponse(true);
      }
      if (value !== "" && timeOfDay > 0) {
        try {
          const response = await axios.post(
            API_URL + `/remindermed/${userData.cookie}`,
            formData
          );

          if (response.data.error_msg === 200) {
            setApiResponse({
              title: "OK",
              severity: "success",
              info: "Lek dopisany!",
            });
          } else {
            setApiResponse({
              title: "UWAGA",
              severity: "error",
              info: "Nie udało się dopisać. Spróbuj za chwilę lub skontaktuj się z administratorem!",
            });
            setShowApiResponse(true);
          }
        } catch (error) {
          setApiResponse({
            title: "Błąd",
            severity: "error",
            info: "Błąd podczas edycji. Spróbuj za chwilę lub skontaktuj się z administratorem!",
          });
          setShowApiResponse(true);
        }
      }
    } else {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Brak wybranego leku!",
      });
      setShowApiResponse(true);
    }
    //}
  };
  const validateDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) {
      return null; // Format nie pasuje
    }
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {
      return dateString;
    } else {
      return null;
    }
  };
  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Row style={{ marginBottom }}>
        <Col md={4}>
          <Autocomplete
            value={selectedOption}
            onChange={(event, newValue) => {
              setSelectedOption(newValue);
              setShowApiResponse(false);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              }
              return option.bow ? option.bow : "";
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                label="Wybierz lub wpisz i dodaj lek"
                variant="outlined"
              />
            )}
          />
          <Button variant="contained" onClick={handleAddNewOption}>
            <AddToPhotosSharpIcon />
          </Button>
          Wpisz nowy lek, a następnie zatwierdź '+'
        </Col>
        <Col md={2}>
          {" "}
          <TextField
            label="Wprowadź ilość"
            variant="outlined"
            value={value}
            onChange={handleChangeInput}
            fullWidth
          />
        </Col>
        <Col md={3}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="time-of-day-label">Pora dnia</InputLabel>
            <Select
              labelId="time-of-day-label"
              value={timeOfDay}
              onChange={handleChange}
              label="Pora dnia"
            >
              {partsofday &&
                partsofday.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.part}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Col>
        <Col md={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={pl}>
            <DatePicker
              label="Wybierz datę"
              value={selectedDate}
              onChange={handleDateChange}
              format="yyyy-MM-dd"
              slotProps={{ textField: { variant: "outlined" } }}
              minDate={addDays(new Date(), 1)}
            />
          </LocalizationProvider>
        </Col>
        <Col md={1}>
          <Button variant="contained" onClick={handleSubmit}>
            <CheckSharpIcon />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
